export default "__VITE_ASSET__3bf6c428__"